var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "_900 big",
    attrs: {
      "id": "Client-name"
    }
  }, [_vm._v(" Pridanie " + _vm._s(_vm.getFullLabelType(_vm.type)) + " ")])]), _c('div', {
    staticClass: "w-form"
  }, [_c('div', {
    staticClass: "form-2",
    attrs: {
      "id": "email-form"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "option-block",
    attrs: {
      "data-w-id": "8466810e-7557-a963-e1a4-1ff5d954c81e"
    },
    on: {
      "click": function click($event) {
        return _vm.propertyTypePicker('house');
      }
    }
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v("rodinný dom")])]), _c('div', {
    staticClass: "option-block",
    attrs: {
      "data-w-id": "815ce0e9-0210-f8e5-3b0d-1a7cbddd7f06"
    },
    on: {
      "click": function click($event) {
        return _vm.propertyTypePicker('flatInHouse');
      }
    }
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v("byt v rodinnom dome")])]), _c('div', {
    staticClass: "option-block",
    attrs: {
      "data-w-id": "7cf0ddfc-1840-5f61-2b30-9494c9becaa4"
    },
    on: {
      "click": function click($event) {
        return _vm.propertyTypePicker('flatInFlat');
      }
    }
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v("byt v bytovom dome")])]), _c('div', {
    staticClass: "option-block",
    attrs: {
      "data-w-id": "0802c97d-bcad-27ac-d75b-f75f48e0a1e5"
    },
    on: {
      "click": function click($event) {
        return _vm.propertyTypePicker('land');
      }
    }
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v("pozemok")])]), _c('div', {
    staticClass: "splitter"
  }, [_vm._v("2. alebo vyberte z už pridaných")]), _vm._l(_vm.properties.propertiesObjects, function (property, key) {
    return _c('div', {
      key: key,
      staticClass: "input-block p-relative"
    }, [_c('div', {
      staticClass: "div-block-101"
    }, [_vm._v(" " + _vm._s(_vm.getAddressModified(property)) + " "), _vm.isSharedFromAnotherModeling(property.id) ? _c('span', {
      staticClass: "shared-property-label"
    }, [_vm._v(" z inej modelácie rovnakých žiadateľov ")]) : _vm._e(), property.loading ? _c('v-progress-circular', {
      staticClass: "loading-spinner extrasmall",
      attrs: {
        "indeterminate": ""
      }
    }) : _c('div', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(_vm._f("dotTheAmount")(property.hodnota)) + " EUR")])], 1), _c('div', {
      staticClass: "div-block-112"
    }, [_c('div', {
      staticClass: "text-cta",
      on: {
        "click": function click($event) {
          return _vm.edit(property);
        }
      }
    }, [_vm._v("EDIT")]), !_vm.isUsed(property.id) ? _c('div', {
      staticClass: "text-cta",
      on: {
        "click": function click($event) {
          return _vm.pick(property.id);
        }
      }
    }, [_vm._v(" PICK ")]) : _vm._e()])]);
  })], 2)])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "splitter"
  }, [_vm._v(" 1. Vyberte typ "), _c('strong', [_vm._v("nehnuteľnosti")]), _vm._v(", ktorú chcete pridať ")]);

}]

export { render, staticRenderFns }